import { combineReducers } from 'redux';
import {
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_OUTLETS,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_LIST,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_ITEM,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_SUMMARY,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_FILTER_STATE,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_CURRENT_PAGE,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_TOTAL_PAGE,
  TABLE_MANAGEMENT_VOID_ITEM_REPORT_UNSET_FILTER_STATE,
} from 'actions/tableManagement/constants';
import createReducer from 'utils/createReducer';

const outlets = createReducer([], {
  [TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_OUTLETS]: (draft, { payload }) =>
    payload.outlets,
});

const reports = createReducer([], {
  [TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_LIST]: (draft, { payload }) =>
    payload.reports,
});

const item = createReducer(null, {
  [TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_ITEM]: (draft, { payload }) =>
    payload.report,
});

const summary = createReducer(
  { total_pages: 0, total_items: 0, completed: 0, cancelled: 0 },
  {
    [TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_SUMMARY]: (draft, { payload }) =>
      payload.reportSummary,
  }
);

const filterState = createReducer(
  { keyword: '' },
  {
    [TABLE_MANAGEMENT_VOID_ITEM_REPORT_UNSET_FILTER_STATE]: () => ({
      keyword: '',
    }),

    [TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_FILTER_STATE]: (
      draft,
      { payload }
    ) => ({
      keyword: payload.keyword,
    }),
  }
);

const totalPage = createReducer(null, {
  [TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_TOTAL_PAGE]: (draft, { payload }) =>
    payload.totalPage,
});

const currentPage = createReducer(null, {
  [TABLE_MANAGEMENT_VOID_ITEM_REPORT_SET_CURRENT_PAGE]: (draft, { payload }) =>
    payload.currentPage,
});

export default combineReducers({
  outlets,
  reports,
  item,
  summary,
  filterState,
  totalPage,
  currentPage,
});
